import {DocumentTemplateSummaryModel} from '../documentTemplateSummary.model';
import {Injectable} from '@angular/core';
import {HttpModelConverter} from "../../../../../core/converter/httpModel.converter";

@Injectable({
    providedIn: 'root'
})
export class DocumentTemplateSummaryConverter extends HttpModelConverter<DocumentTemplateSummaryModel> {
    protected createInstance(): DocumentTemplateSummaryModel {
        return new DocumentTemplateSummaryModel();
    }

    protected enrichObject(result: DocumentTemplateSummaryModel, src: DocumentTemplateSummaryModel) {
    }
}
